// extracted by mini-css-extract-plugin
export var footer = "_pb-0";
export var inherit = "_pb-1";
export var input = "_pb-2";
export var modalContent = "_pb-3";
export var quillEditor = "_pb-4";
export var subtitle = "_pb-5";